// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h3{font-size:1rem;font-weight:bolder}.panel{padding:1rem 2rem;margin-bottom:1.5rem;background:#fff;border-radius:5px}", ""]);
// Exports
module.exports = exports;
